var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"niste-clan"},[_c('div',[_vm._v("Trenutno u pripremi. Dolazi uskoro..")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Povratak na početnu")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }